import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopoverModule, TooltipModule } from 'ngx-bootstrap';
import { RequisitionCardComponent } from './requisition-card.component';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { RequisitionCardIconsModule } from 'src/app/shared/requisition-card-icons/requisition-card-icons.module';
import { RecentActivitiesModule } from 'src/app/shared/recent-activities/recent-activities.module';
import { InfoIconModule } from 'src/app/shared/info-icon/info-icon.module';
import { HiringManagersPopoverModule } from './hiring-managers-popover/hiring-managers-popover.module';
import { RecruitersPopoverModule } from './recruiters-popover/recruiters-popover.module';
import { NotificationsPageModule } from 'src/app/pages/mission-control-page/notifications-page/notifications-page.module';

@NgModule({
  declarations: [RequisitionCardComponent],
  imports: [
    CommonModule,
    TooltipModule.forRoot(),
    PopoverModule.forRoot(),
    PipesModule,
    RequisitionCardIconsModule,
    RecentActivitiesModule,
    InfoIconModule,
    HiringManagersPopoverModule,
    RecruitersPopoverModule,
    NotificationsPageModule
  ],
  exports: [RequisitionCardComponent],
  entryComponents: [RequisitionCardComponent],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA]
})
export class RequisitionCardModule { }
